<template>
  <div v-if="response">
    <document-container
      v-if="response"
      :header="header"
      :logo="logo"
      :timeout="3000"
      documentType="whitelabel"
    >
      <chart-container
        slot="raw-body"
        :chartData="chartData"
        :chartType="'ChartReport'"
        :heading="'Kursentwicklung Produkt (' + getTimeFrame + ')'"
        :settings="{
                style: {
                  width: 1000,
                  height: 500
                }
              }"
      ></chart-container>
    </document-container>

    <document-container
      v-for="(table, key) in tables.tables"
      :key="'table-' + key"
      :header="header"
      :logo="logo"
      :tables="tables"
      :timeout="3000"
      documentType="whitelabel"
    >
      <div
        slot="raw-body"
        class="page-block">

        <table-whitelabel
          :table="tables.findTable(table.id)"
        ></table-whitelabel>

      </div>
    </document-container>
    <document-container
      documentType="whitelabel"
    >
      <div
        slot="raw-body"
        class="page-block">
        <h2>Datenquellen</h2>
        <table style="width:300px">
          <tr>
            <td v-for="img in response.dataSuppliers" style="width:100px">
              <img :src="'https://files.dericon.de/' + img.logo" alt="" width="100">
            </td>
          </tr>
          <tr>
            <td v-for="name in response.dataSuppliers" style="width:100px">
              {{ name.name }}
            </td>
          </tr>
        </table>
      </div>
      <div
        slot="raw-body"
        class="page-block">

        <textblock
          :data='{body:["Kurse und Kennzahlen: Angezeigte Daten sind nicht in Echtzeit. Tatsächliche Konditionen können aufgrund zwischenzeitlicher Kursänderungen abweichen." ]}'
        >
        </textblock>
      </div>
      <div
        slot="raw-footer"
        class="page-block">

        <textblock
          :data="footerDisclaimer"
        >
        </textblock>
      </div>
    </document-container>

  </div>
</template>

<script>
import ProductService from '../../service/ProductService'
import DocumentContainer from '../document/DocumentContainer'
import BlockMixin from '../block/BlockMixin'
import {Table} from '../../model/table/Table'
import {TableCollection} from '../../model/table/TableCollection'
import TokenService from "../../service/TokenService"
import TableWhitelabel from "../table/TableWhitelabel.vue";
import ChartContainer from "../chart/ChartContainer.vue";

export default {
  components: {
    ChartContainer,
    TableWhitelabel,
    DocumentContainer,
  },

  name: 'whitelabel',

  data() {
    return {
      product: {},
      chartData: null,
      response: null,
      config: null,
      labels: {},
      TableWhitelabel,
      tables: null,
      token: null,
      dqs: null,
      footerDisclaimer: {
        "position": "footer",
        "type": "Textblock",
        "class": "fineprint",
        "body": ["Bei diesem Dokument handelt es sich um eine Marketingmitteilung. Es stellt keine Finanzanalyse im Sinne des § 85 WpHG, keine Anlageberatung, Anlageempfehlung oder Aufforderung zum Kauf von Finanzinstrumenten dar. Dieses Dokument gibt lediglich eine zusammenfassende Kurzdarstellung wesentlicher Merkmale der Wertpapiere wider und ersetzt keine rechtliche, steuerliche oder finanzielle Beratung. Die gemachten Angaben wurden nicht durch eine außenstehende Partei, insbesondere eine unabhängige Wirtschaftsprüfungsgesellschaft, geprüft. Ausführlichere Informationen entnehmen Sie bitte dem jeweiligen Basisinformationsblatt."],
        "sort": 60
      }
    }
  },

  mixins: [BlockMixin],

  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: '/config/' + this.environment + '/style/report.css'
        }
      ]
    }
  },

  props: {
    environment: {
      type: String
    },
    appInstance: {
      type: String,
      required: false,
    }
  },

  methods: {
    mapChartData() {

      let colors = [
        '#1A4AA0',
        '#1a95a0',
        '#1aa030',
        '#a0391a',
        '#a0761a'
      ]

      return {
        labels: this.response.chartBuilderResponse.chart.seriesList[0].values.map(el => {
          return this.moment(el.x, 'YYYY-MM-DD').format()
        }),
        datasets: this.response.chartBuilderResponse.chart.seriesList.map((el, i) => {
            return {
              label: el.label,
              borderColor: colors[i],
              fill: false,
              lineTension: 0,
              borderJoinStyle: 'round',
              backgroundColor: 'rgba(0,0,0,0)',
              pointRadius: 0,
              data: el.values,
              borderWidth: 7
            }
          }
        )
      }
    }
  },

  computed: {
    logo() {
      return '/config/' + this.environment + '/images/logo.png'
    },
    header() {
      return [{
        type: 'Pagetitle',
        title: 'Fonds-Vergleich',
        position: 'header',
        sort: 1,
        shared: true,
      }]
    },
    getTimeFrame() {
      let dict = {
        YEARS: 'Jahre',
        MONTHS: 'Monate',
        WEEKS: 'Wochen'
      }
      if (this.config.category.timeFrame.mode === 'YTD') {
        return 'YTD'
      } else if (this.config.category.timeFrame.mode === 'ISSUE_DATE') {
        return 'Maximaler Zeitraum'
      } else {
        return `${this.config.category.timeFrame.range} ${dict[this.config.category.timeFrame.unit]}`
      }
    }
  },

  async created() {
    this.dqs = this.$route.query.dqs
    if (!this.$route.query.token) {
      this.token = await TokenService.checkToken()
    } else {
      this.token = this.$route.query.token
    }
    this.config = JSON.parse(decodeURIComponent(this.$route.query.config))

    // if (this.$route.query.date) {
    //   options.push(
    //     {
    //       name: 'date',
    //       value: this.$route.query.date
    //     }
    //   )
    // }
    // if (this.$route.query.quote) {
    //   options.push(
    //     {
    //       name: 'quote',
    //       value: this.$route.query.quote
    //     }
    //   )
    // }

    ProductService.getWhitelabel(
      this.environment,
      this.appInstance,
      this.config,
      this.token,
      this.dqs
    ).then(res => {
      this.response = res.data
      this.chartData = this.mapChartData()
      let tables = []

      this.response.productData.map((el, i) => {
        if (i % 3 === 0) {
          tables.unshift([])
        }
        tables[0].push(el)
      })
      this.tables = new TableCollection(
        ...tables.reverse().map((el, i) => {
            console.log(el)
            return new Table(
              'product-table-' + i,
              this.response.tableStructure.columns,
              el,
              TableWhitelabel,
              'Produktdaten'
            )
          }
        ))
    })
  }
}
</script>

<style lang="scss">
.whitelabel .table td:first-child {
  width: 130px
}
</style>



// WEBPACK FOOTER //
// Whitelabel.vue?fc2b11e2